module.exports = __webpack_public_path__ + "1a255933eb0d22d28a0cbb1103ea7047.svg";